import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import type { IssueStartResult, Severity } from '../../types/domain.types';

export const warnHooterNotSilenced = (t: TFunction): void => {
  toast.warn(t('closeTheLoop.inApp.hooterNotSilenced', 'Couldn’t silence the hooter — check on site'));
};

export const hooterLeftSounding = (severity: Severity | undefined, result: IssueStartResult): boolean =>
  severity === 'EMERGENCY' && result.outcome === 'STARTED' && !result.hooterSilenced;
